<template>
  <!-- 🔹 CONTENEDOR PRINCIPAL (tipo modal simple) -->
  <div v-if="visible" class="overlay-servicio">

    <div class="pos-servicios">

      <!-- BOTÓN CERRAR -->
      <button class="btn-cerrar" @click="cerrar">✖</button>

      <!-- IZQUIERDA: SERVICIOS -->
      <div class="panel-servicios">
        <h2>Servicios</h2>

        <div v-if="servicios.length === 0">
  No hay servicios cargados
</div>

        <input v-model.trim="busqueda" placeholder="Buscar servicio..." class="input-busqueda" />

        <div class="grid-servicios">
          <button v-for="srv in serviciosFiltrados" :key="srv.idServicio" @click="seleccionarServicio(srv)"
            :class="{ activo: servicioSeleccionado && servicioSeleccionado.idServicio === srv.idServicio }">
            <img v-if="srv.logoSrc" :src="srv.logoSrc || 'https://via.placeholder.com/40'" class="img-servicio" />

            <span>{{ srv.servicio }}</span>
          </button>
        </div>
      </div>

      <!-- DERECHA: DETALLE -->
      <div class="panel-detalle">

        <h2>Pago</h2>
        <div v-if="servicioSeleccionado">
          <h3>{{ servicioSeleccionado.servicio }}</h3>

          <div class="grid-productos">
            <button v-for="prod in productos" :key="prod.idProducto" @click="seleccionarProducto(prod)"
              :class="{ activo: productoSeleccionado && productoSeleccionado.idProducto === prod.idProducto }">
              <img v-if="prod.logoSrc" :src="prod.logoSrc || 'https://via.placeholder.com/40'" class="img-producto" />

              <span>{{ prod.producto }}</span>
              <small>${{ prod.precio }}</small>
            </button>
          </div>
        </div>
        <div v-if="this.verPago">
          <div class="campo">
            <label>Referencia</label>
            <input v-model="referencia" @keyup.enter="consultarServicio" />
          </div>

          <div v-if="this.verConsulta">
            <button class="btn-consultar" @click="consultarServicio">
              Consultar
            </button>
          </div>


          <div v-if="cliente">
            <p><b>Cliente:</b> {{ cliente }}</p>
            <p><b>Adeudo:</b> ${{ adeudo }}</p>
          </div>

          <div class="pagos">
            <button @click="metodoPago = 'efectivo'" :class="{ activo: metodoPago === 'efectivo' }">
              Efectivo
            </button>

            <button @click="metodoPago = 'tarjeta'" :class="{ activo: metodoPago === 'tarjeta' }">
              Tarjeta
            </button>
          </div>

          <div v-if="metodoPago === 'efectivo'" class="campo">
            <label>Recibido</label>
            <input v-model.number="recibido" />
          </div>

          <p v-if="metodoPago === 'efectivo'">
            <b>Cambio:</b> ${{ cambio }}
          </p>

          <button class="btn-pagar" @click="pagar">
            PAGAR
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import dataServicios from "@/assets/servicios.json";
import { consultarServicios } from "@/services/terpayApi.js";
export default {
  name: "ServiciosComponent",


  props: {
    value: Boolean
  },

  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    serviciosFiltrados() {
      const texto = this.busqueda.toLowerCase();

      return this.servicios.filter(srv =>
        srv.servicio.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .includes(texto.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
      );
    },

    cambio() {
      return this.recibido - this.adeudo;
    }
  },

  data() {
    return {
      servicios: [],
      productoSeleccionado: null,
      servicioSeleccionado: null,
      productos: [],
      verConsulta: false,
      verPago: false,
      referencia: "",
      busqueda: "",
      cliente: "",
      adeudo: 0,
      metodoPago: null,
      recibido: 0
    };
  },

  mounted() {
    this.cargarServicios();
  },


  methods: {
    cerrar() {
      this.visible = false;
      this.referencia = "";
      this.cliente = "";
      this.adeudo = 0;
      this.recibido = 0;
      this.metodoPago = null;
      this.productoSeleccionado = null;
      this.verPago = false;
      this.verConsulta = false;
      this.servicioSeleccionado = false;
      this.$nextTick(() => {
        this.$emit("nuevo-pos-enc");
      });
    },

    seleccionarServicio(srv) {
      this.servicioSeleccionado = srv;
      this.productos = srv.productoDTOList;
      this.productoSeleccionado = null;
      this.verPago = false;
      this.verConsulta = false;

    },
    // cargarServicios() {
    //   this.servicios = dataServicios
    //     .filter(x => x.serviciosDTOS)
    //     .flatMap(x => x.serviciosDTOS);
    // },

    async cargarServicios() {
  try {
    const data = await consultarServicios();

    console.log("DATA REAL:", data);

    this.servicios = data
      .flatMap(x => x.serviciosDTOS);

  } catch (error) {
    console.error("Error cargando servicios:", error);
    this.servicios = [];
  }
},


    consultarServicio() {

      if (!this.referencia) {
        throw alert("Capture Referencia");
      }
      this.cliente = "Juan Pérez";
      this.adeudo = 1250;
      
    },


    seleccionarProducto(prod) {
      this.productoSeleccionado = prod;
      console.log(this.productoSeleccionado);
      this.verPago = true;
      if (this.productoSeleccionado.tipoFront == 2) {
        this.verConsulta = true;
      }

    },

    pagar() {
      if (!this.productoSeleccionado) {
        alert("Selecciona un producto");
        return;
      }
      if (!this.servicioSeleccionado) {
        alert("Selecciona un servicio");
        return;
      }

      if (!this.referencia) {
        alert("Captura referencia");
        return;
      }

      alert("Pago realizado correctamente");

      // reset
      this.referencia = "";
      this.cliente = "";
      this.adeudo = 0;
      this.recibido = 0;
      this.metodoPago = null;
      this.productoSeleccionado = null;
      this.verPago = false;
      this.verConsulta = false;
      this.servicioSeleccionado = null;


      this.cerrar();

    }
  }
};
</script>

<style>
/* overlay  */
.overlay-servicio {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}

.pos-servicios {
  display: flex;
  height: 100vh;
  font-family: Arial;
  background: white;
}

/* botón cerrar */
.btn-cerrar {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  background: red;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}

/* panel servicios */
.panel-servicios {
  width: 40%;
  background: #1e1e2f;
  color: white;
  padding: 20px;
  overflow-y: auto;

}

.grid-servicios {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  overflow-y: auto;
  flex: 1;
}

.grid-servicios button {
  padding: 20px;
  font-size: 18px;
  border: none;
  background: #2e2e40;
  color: white;
  cursor: pointer;
}

.grid-servicios button.activo {
  background: #00c853;
}

/* panel detalle */
.panel-detalle {
  width: 60%;
  padding: 20px;
  background: #f5f5f5;
  height: 100vh;
  overflow-y: auto;
  /* display: flex;
  flex-direction: column; */
}

.campo {
  margin-bottom: 10px;
}

input {
  width: 100%;
  padding: 10px;
  font-size: 18px;
}

.pagos button {
  margin-right: 10px;
  padding: 10px 20px;
}

.btn-pagar {
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  font-size: 20px;
  background: #00c853;
  color: white;
  border: none;
}

.grid-productos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 15px;
  overflow-y: visible;
  max-height: none;

}

.grid-productos button {
  padding: 15px;
  font-size: 16px;
  border: none;
  background: #ddd;
  cursor: pointer;
}

.grid-productos button.activo {
  background: #00c853;
  color: white;
}

.input-busqueda {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  font-size: 25px;
  border: none;
  border-radius: 5px;
  outline: none;
  color: #fff !important;
  background: #2e2e40 !important;
  -webkit-text-fill-color: #fff;
}

.input-busqueda::placeholder {
  color: #ccc;
}

.input-busqueda:focus {
  color: #fff !important;
  -webkit-text-fill-color: #fff;
}

.grid-servicios button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.img-servicio {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 5px;
}

.grid-productos button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.img-producto {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-bottom: 5px;
}
</style>